<template>
  <button
    data-cy="continue-button"
    class="btn pj-wide"
    :disabled="!isEnabled"
    :class="isEnabled ? className : ' pj-disable-btn'"
    :type="type"
    @click="nextStep"
  >
    <slot>{{ label }}</slot>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "ButtonContinue",
  props: {
    className: { type: String, default: "pj-green-btn" },
    isEnabled: { type: Boolean, default: false },
    label: { type: String, default: "Continue" },
    nextRoute: String,
    type: String,
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();

    const nextStep = () => {
      emit("callback");
      router.push({
        name: props.nextRoute as string,
        query: route.query,
      });
    };

    return { t, nextStep };
  },
});
</script>
